import React from 'react'

const TeamItem = ({item}) => {
    
  return (
    <div className="managamenet-team-card">
    <div className="managament-team-wrap">
    <div className="managament-member-image">
        <img src={item.img} alt="" />
    </div>
    <div className="managament-member-line"></div>
    <div className="managament-member-info">
        <div className="management-member-name">
            <p>{item.name}</p>
        </div>
        <div className="managament-member-department">
            <p>{item.department}</p>
        </div>
    </div>

    </div>
</div>
  )
}

export default TeamItem